// Module
var code = "<svg width=\"24\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill=\"#000\" fill-rule=\"evenodd\">\n    <rect width=\"24\" height=\"2\" rx=\"1\"/>\n    <rect y=\"7\" width=\"24\" height=\"2\" rx=\"1\"/>\n    <rect y=\"14\" width=\"24\" height=\"2\" rx=\"1\"/>\n  </g>\n</svg>\n";
// Exports
export default code;